import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { boolean, index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { BookCollectionToBook } from './book-collection-to-book'

export const BookCollection = pgTable(
  'book_collection',
  {
    id: uuid().notNull().primaryKey(),
    slug: text().notNull(),
    name: text().notNull(),
    description: text().notNull(),
    coverKey: text().notNull(),
    isActive: boolean().notNull().default(true),
    likesCount: integer().notNull().default(0),
    viewsCount: integer().notNull().default(0),
    legacyCollectionId: integer(),
    legacyNeonBookCollectionId: text(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('book_collection_legacy_collection_id_idx').on(columns.legacyCollectionId),
    index('book_collection_slug_idx').on(columns.slug),
    index('book_collection_legacy_neon_book_collection_id_idx').on(columns.legacyNeonBookCollectionId),
    index('book_collection_updated_at_idx').on(columns.updatedAt),
    index('book_collection_created_at_idx').on(columns.createdAt),
    index('book_collection_is_active_idx').on(columns.isActive),
    index('book_collection_likes_count_idx').on(columns.likesCount),
    index('book_collection_views_count_idx').on(columns.viewsCount),
  ],
)

export const bookCollectionRelations = relations(BookCollection, ({ many }) => ({
  bookCollectionToBooks: many(BookCollectionToBook),
}))

export const InsertBookCollectionSchema = createInsertSchema(BookCollection)
export const UpdateBookCollectionSchema = createUpdateSchema(BookCollection)
  .omit({ id: true, legacyCollectionId: true, legacyNeonBookCollectionId: true })
  .partial()
export const SelectBookCollectionSchema = createSelectSchema(BookCollection)

export type InsertBookCollection = typeof BookCollection.$inferInsert
export type UpdateBookCollection = z.infer<typeof UpdateBookCollectionSchema>
export type SelectBookCollection = typeof BookCollection.$inferSelect
